import types from '../../constants';
import auth from '../../auth';

export function showHideVariables() {
  return { type: types.BLACKLIST_SHOW_HIDE_VARIABLES };
}

export function changeVariable(variable, value) {
  return {
    type: types.BLACKLIST_CHANGE_VARIABLE,
    payload: {
      variable,
      value,
    }
  };
}

export function fetchBlackList() {
  return async (dispatch) => {
    dispatch({ type: types.BLACKLIST_FETCH_START });

    fetch('/api/blacklist', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((blacklist) => {
        fetch('/api/config/blacklist', {
          method: 'GET',
          headers: {
            pragma: 'no-cache',
            Accept: 'application/json',
            Authorization: localStorage.token,
          },
        })
        .then((configResponse) => {
          if (configResponse.status === 403 || configResponse.status === 401) {
            auth.logoutAndRedirect();
            throw new Error('Not authenticated.');
          }

          return configResponse.json();
        })
        .then((config) => {
          dispatch({
            type: types.BLACKLIST_FETCH_END,
            payload: {
              blacklist: blacklist.blacklist,
              config: config.config.data,
            },
          });
        })
      })
      .catch(err => console.log(err)); // eslint-disable-line

    return true;
  };
}

export function deleteEntry(id) {
  return async (dispatch) => {
    dispatch({ type: types.BLACKLIST_DELETE_START });
    fetch(`/api/blacklist/${id}`, {
      method: 'DELETE',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        dispatch({ type: types.BLACKLIST_DELETE_END });
      })
      .catch((err) => {
        dispatch({ type: types.BLACKLIST_DELETE_END });
        console.log(err); // eslint-disable-line
      });

    return true;
  };
}

export function submitVariables(variables) {
  return async (dispatch) => {
    dispatch({ type: types.BLACKLIST_UPDATE_START });
    fetch(`/api/config/blacklist`, {
      method: 'PUT',
      body: JSON.stringify(variables),
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        dispatch({ type: types.BLACKLIST_UPDATE_END });
      })
      .catch((err) => {
        dispatch({ type: types.BLACKLIST_UPDATE_END });
        console.log(err); // eslint-disable-line
      });

    return true;
  };
}
